import { axiosGet, axiosPost, axiosGetBlob } from "./apiClient";

// Base URL setup
const BASE_URL = `${process.env.REACT_APP_BASE_URL}/report`;

// Get All Employees
const getSaleOrders = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = {}, fromDate = null, toDate = null, fieldType = 'Delivered', fieldFDate = null, fieldTDate = null, branchId = null }) => {
    let sendStatus = status === 0 ? null : status;
    const search = filterModel?.quickFilterValues?.[0] ?? null;
    return await axiosPost(`${BASE_URL}/saleorders`, {
        limit,
        page,
        sendStatus,
        search,
        sort: sortModel,
        fromDate,
        toDate,
        fieldType,
        fieldFDate,
        fieldTDate,
        branchId
    });
};
const getDeliveryPerformance = async (params) => {
    return await axiosPost(`${BASE_URL}/delivery-performance`, { ...params });
}
const getDeliveryExecutivePerformance = async (params) => {
    return await axiosPost(`${BASE_URL}/delivery-executive-performance`, { ...params });
}

const getSalesProductReport = async ({
    limit = 10,
    page = 0,
    search = "",
    branchId = null,
    fromDate = null,
    toDate = null,
    top = null // can be 'pri' or 'qty'
}) => {
    const payload = {
        length: limit,
        start: page * limit, // convert page to start index
        search,
        branchId,
        fromDate,
        toDate,
        top
    };

    return await axiosPost(`${BASE_URL}/sales/products`, payload);
};

export const getDeliveredOrderTimeline = async ({
    limit = 10,
    page = 0,
    sort = [],
    search = "",
    fromDate = null,
    toDate = null,
    branchId = null,
    status = null,
}) => {
    const payload = { limit, page, sort, search, fromDate, toDate, branchId, status };
    return await axiosPost(`${BASE_URL}/delivered-order-timeline`, payload);
};

const getDashboardSummary = async ({ branchId = null, fromDate = null, toDate = null } = {}) => {
    return await axiosPost(`${BASE_URL}/dashboard-summary`, { branchId, fromDate, toDate });
};

const getOnlineOrdersReport = async ({
    limit = 50,
    page = 0,
    search = "",
    fromDate = null,
    toDate = null,
    branchIds = null,     // ✅ array
    placedTypes = null,   // ✅ array
    refundedOnly = false,
} = {}) => {
    return await axiosPost(`${BASE_URL}/online-orders`, {
        limit,
        page,
        search: search || null,
        fromDate,
        toDate,
        branchIds,
        placedTypes,
        refundedOnly,
    });
};

const exportOnlineOrdersReport = async ({
    search = "",
    fromDate = null,
    toDate = null,
    branchIds = null,
    placedTypes = null,
    refundedOnly = false,
} = {}) => {
    return await axiosGetBlob(`${BASE_URL}/online-orders/export`, null, {
        search: search || null,
        fromDate,
        toDate,
        branchIds: Array.isArray(branchIds) ? branchIds.join(",") : null,        // ✅ send as CSV
        placedTypes: Array.isArray(placedTypes) ? placedTypes.join(",") : null,  // ✅ send as CSV
        refundedOnly: refundedOnly ? "true" : "false",
    });
};

const getPickerPackerActivityReport = async (params) => {
    return await axiosPost(`${BASE_URL}/picker-packer-activity`, { ...params });
};
const getPickerPackerSummary = async (params) => {
    return await axiosPost(`${BASE_URL}/picker-packer/summary`, { ...params });
};

const getPickerPackerItemChanges = async (params) => {
    return await axiosPost(`${BASE_URL}/picker-packer/item-changes`, { ...params });
};

const getPickerPackerOrderTime = async (params) => {
    return await axiosPost(`${BASE_URL}/picker-packer/order-time`, { ...params });
};


// Export the API functions
const reportApi = {
    getSaleOrders,
    getDeliveryPerformance,
    getDeliveryExecutivePerformance,
    getSalesProductReport,
    getDeliveredOrderTimeline,
    getDashboardSummary,
    getOnlineOrdersReport,
    exportOnlineOrdersReport,
    getPickerPackerActivityReport,
    getPickerPackerSummary,
    getPickerPackerItemChanges,
    getPickerPackerOrderTime,
};

export default reportApi;